import React from 'react';
import { FaBatteryFull, FaBatteryThreeQuarters, FaBatteryHalf, FaBatteryQuarter, FaBatteryEmpty } from 'react-icons/fa';

function IotmateBatteryIcon({ level }) {
  let BatteryIconComponent;
  let batteryColor;
  let bgColor;

  // Determine which battery icon and color to use based on the charge level
  if (level >= 80) {
    BatteryIconComponent = FaBatteryFull;
    batteryColor = '#10b981'; // Green
    bgColor = 'rgba(16, 185, 129, 0.1)';
  } else if (level >= 60) {
    BatteryIconComponent = FaBatteryThreeQuarters;
    batteryColor = '#3b82f6'; // Blue
    bgColor = 'rgba(59, 130, 246, 0.1)';
  } else if (level >= 40) {
    BatteryIconComponent = FaBatteryHalf;
    batteryColor = '#f59e0b'; // Amber
    bgColor = 'rgba(245, 158, 11, 0.1)';
  } else if (level >= 20) {
    BatteryIconComponent = FaBatteryQuarter;
    batteryColor = '#f97316'; // Orange
    bgColor = 'rgba(249, 115, 22, 0.1)';
  } else {
    BatteryIconComponent = FaBatteryEmpty;
    batteryColor = '#ef4444'; // Red
    bgColor = 'rgba(239, 68, 68, 0.1)';
  }

  return (
    <div 
      style={{ 
        display: 'flex', 
        alignItems: 'center',
        gap: '8px',
        padding: '6px 12px',
        background: bgColor,
        borderRadius: '8px',
        border: `1px solid ${batteryColor}20`,
        transition: 'all 0.3s ease'
      }}
    >
      <BatteryIconComponent 
        size={20} 
        style={{ color: batteryColor }}
      />
      <span 
        style={{ 
          fontSize: '13px',
          fontWeight: '600',
          color: batteryColor,
          letterSpacing: '0.3px'
        }}
      >
        {level.toFixed(0)}%
      </span>
    </div>
  );
}

export default IotmateBatteryIcon;